import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BulkActionsToolbar = ({ 
  selectedCount, 
  onSuspend, 
  onActivate,
  onDelete,
  onClearSelection 
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-xl p-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-md bg-primary flex items-center justify-center">
          <Icon name="CheckSquare" size={20} color="white" />
        </div>
        <div>
          <p className="font-heading font-medium text-foreground">
            <span className="data-text">{selectedCount}</span>명 선택됨
          </p>
          <button
            onClick={onClearSelection}
            className="text-sm caption text-primary hover:underline transition-athletic"
          >
            선택 해제
          </button>
        </div>
      </div>

      <div className="flex flex-wrap gap-2 w-full md:w-auto">
        <Button
          variant="outline"
          size="sm"
          iconName="Ban"
          iconPosition="left"
          onClick={onSuspend}
        >
          정지
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="CheckCircle"
          iconPosition="left"
          onClick={onActivate}
        >
          활성화
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Trash2"
          iconPosition="left"
          onClick={onDelete}
        >
          삭제
        </Button>
      </div>
    </div>
  );
};

export default BulkActionsToolbar;